import { useQuery } from '@tanstack/react-query';

import { hrApi } from '@/api';
import { queryKeys, tierOptions } from '@/lib/query';

/** Linked employees.id for the signed-in user (ESS profile), when available. */
export function useCurrentEmployeeId() {
  const { data } = useQuery({
    queryKey: queryKeys.hr.essProfile(),
    queryFn: () => hrApi.essProfile(),
    // Keep options aligned with HrEssPortalPage so shared-cache observers do not fight.
    ...tierOptions('operational'),
    select: (profile) => profile?.employee?.id ?? null,
  });

  return data ?? null;
}
